import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ValidationModule } from '../validation/validation.module';
import { HintsService } from './hints.service';
import { HintsComponent } from './hints.component';
import { HintsDirective } from './hints.directive';
import { HintsContainerDirective } from './hints-container.directive';
import { HintsValidationComponent } from './hints-validation/hints-validation.component';


@NgModule({
    imports: [CommonModule, ValidationModule],
    declarations: [
        HintsComponent,
        HintsDirective,
        HintsContainerDirective, HintsValidationComponent,
        HintsValidationComponent,
    ],
    exports: [
        HintsComponent,
        HintsDirective,
        HintsContainerDirective,
        HintsValidationComponent,
    ],
    providers: [HintsService]
})
export class HintsModule { }
